import { Plus } from 'lucide-react';
import { Fragment } from 'react';

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

import { type IAdditionalFieldType, otherOptionFields as options } from '../../model';

type Props = {
  onSelectOption: (value: IAdditionalFieldType) => void;
};

const MoreOptionsDropdown = ({ onSelectOption }: Props) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Plus /> Add more
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="center" className="w-max">
        {options.map(({ label, value, separator }) => (
          <Fragment key={value}>
            <DropdownMenuItem className="py-2 cursor-pointer" onClick={() => onSelectOption(value)}>
              {label}
            </DropdownMenuItem>

            {separator && <DropdownMenuSeparator />}
          </Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MoreOptionsDropdown;
